import { Badge } from '@mantine/core'

/**
 * Shows the current deployment environment (local / dev / qa / staging) so users and
 * developers always know when they are NOT in production. Renders nothing in production.
 */
export function EnvironmentBadge({ className }: { className?: string }) {
  const environment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || 'local'

  if (environment === 'prod') {
    return null
  }

  return (
    <Badge
      color="brandGold"
      c="black"
      variant="filled"
      radius="sm"
      className={className}
    >
      {environment}
    </Badge>
  )
}
